import { useContext } from "react";
import { createTheme, Grid, Slider, ThemeProvider } from "@mui/material";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { t } from "i18next";
import { LocaleContext } from "../../../routing/LangRouter";
import { numberWithCommas } from "../../../utils/utility";

function FilterRangeSlider({ filterList, filterName, min, max, value, handleChange, handleChangeCommited }) {
    const { locale } = useContext(LocaleContext);

    const theme = createTheme({
        direction: "ltr",
    });

    const ltrCache = createCache({
        key: "mui",
    });

    return (
        <CacheProvider value={ltrCache}>
            <ThemeProvider theme={theme}>
                <Slider
                    step={1}
                    min={min}
                    max={max}
                    value={value}
                    onChange={(event, value) => handleChange(event, value, filterName)}
                    onChangeCommitted={(event, value) =>
                        handleChangeCommited(event, value, filterName, filterList?.[filterName]?.[value[0]], filterList?.[filterName]?.[value[1]])
                    }
                    sx={{
                        color: "var(--secondary-color)",
                        height: 3,
                        "& .MuiSlider-track": {
                            border: "none",
                        },
                        "& .MuiSlider-thumb": {
                            height: 16,
                            width: 16,
                            backgroundColor: "var(--light-color)",
                            border: "2px solid currentColor",
                            "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
                                boxShadow: "inherit",
                            },
                            "&:before": {
                                display: "none",
                            },
                        },
                        "& .MuiSlider-valueLabel": {
                            lineHeight: 1.2,
                            fontSize: 11,
                            background: "unset",
                            padding: "0px !important",
                            width: 24,
                            height: 24,
                            borderRadius: "50% 50% 50% 0",
                            backgroundColor: "var(--secondary-color)",
                            transformOrigin: "bottom left",
                            transform: "translate(50%, -100%) rotate(-45deg) scale(0)",
                            "&:before": { display: "none" },
                            "&.MuiSlider-valueLabelOpen": {
                                transform: "translate(50%, -100%) rotate(-45deg) scale(1)",
                            },
                            "& > *": {
                                transform: "rotate(45deg)",
                            },
                        },
                    }}
                />
                <Grid container item xs={12} justifyContent="space-between">
                    <Grid
                        className="base-filter__range-label"
                        component="span"
                        container
                        item
                        xs={6}
                        justifyContent={locale === "en" ? "flex-start" : "flex-end"}
                        order={locale === "en" ? 1 : 2}
                    >
                        {filterName === "prices"
                            ? numberWithCommas(filterList?.[filterName]?.[value?.[0]]) + t("currency")
                            : filterList?.[filterName]?.[value?.[0]]}
                    </Grid>
                    <Grid
                        className="base-filter__range-label"
                        component="span"
                        container
                        item
                        xs={6}
                        justifyContent={locale === "en" ? "flex-end" : "flex-start"}
                        order={locale === "en" ? 2 : 1}
                    >
                        {filterName === "prices"
                            ? numberWithCommas(filterList?.[filterName]?.[value?.[1]]) + t("currency")
                            : filterList?.[filterName]?.[value?.[1]]}
                    </Grid>
                </Grid>
            </ThemeProvider>
        </CacheProvider>
    );
}

export default FilterRangeSlider;
